import { Spinner, Row, Col, Button, Modal, Image } from 'react-bootstrap'

import GaugeWhite from '../../../../assets/VehicleInfo/alert-icons/GaugeWhite.svg'
import GasPump from '../../../../assets/VehicleInfo/alert-icons/GasPump.svg'
import Truck from '../../../../assets/VehicleInfo/alert-icons/Truck.svg'
import Warning from '../../../../assets/VehicleInfo/alert-icons/Warning.svg'
import Engine from '../../../../assets/VehicleInfo/alert-icons/Engine.svg'
import Package from '../../../../assets/VehicleInfo/alert-icons/Package.svg'
import Flag from '../../../../assets/VehicleInfo/alert-icons/Flag.svg'
import HandPalm from '../../../../assets/VehicleInfo/alert-icons/HandPalm.svg'
import XCircle from '../../../../assets/VehicleInfo/alert-icons/XCircle.svg'
import StopCircle from '../../../../assets/VehicleInfo/alert-icons/StopCircle.svg'
import Swap from '../../../../assets/VehicleInfo/alert-icons/Swap.svg'
import ArrowRight from '../../../../assets/VehicleInfo/alert-icons/ArrowRight.svg'

import { formatDate } from '../../../../utils/format'

import styles from './styles.module.css'
import { useLoading } from '../../../../hooks/LoadingContext'

function VehicleHistoricalModal({ show, close, reportsData, loadMoreAction }) {
  const { isLoading, setIsLoading } = useLoading()

  const reportIconsMap = {
    vehicle_delivered: Flag,
    registered_refuelling: GasPump,
    registered_maintance: Engine,
    on_way_to_delivery: Truck,
    request_delivered: Package,
    speeding: GaugeWhite,
    suspicious_activity: Warning,
    traffic_violation: HandPalm,
    request_canceled: XCircle,
    delivery_interrupted: StopCircle,
    request_transfered: Swap,
    on_way_to_internal_transfer: ArrowRight,
  }

  const handleLoadMore = async () => {
    try {
      setIsLoading(true)
      loadMoreAction(10, reportsData.length)
    } catch (e) {
      console.log(e)
    }
    setIsLoading(false)
  }

  return (
    <Modal size="md" centered show={show} onHide={close}>
      <Modal.Header className="border-0" closeButton />
      <Modal.Body>
        <Row
          className={`${styles.modalRow} border d-flex flex-column justify-content-center align-items-start`}
        >
          {!reportsData.length ? (
            <span className={`${styles.modalInfoBadge} text-center`}>
              Nenhum histórico encontrado
            </span>
          ) : (
            <div>
              {isLoading ? (
                <Spinner
                  animation="border"
                  size="sm"
                  style={{
                    color: '#fff',
                    marginRight: 10,
                  }}
                />
              ) : (
                <div style={{ marginLeft: 20, marginTop: 20 }}>
                  {reportsData?.map((report, index) => (
                    <div key={index}>
                      <Row>
                        <Col className="col-2 text-center">
                          <Image
                            className={styles.historicIcon}
                            width={50}
                            src={reportIconsMap[report.type]}
                          />
                        </Col>
                        <Col className="col-10 d-flex flex-column align-items-start justify-content-center">
                          <span style={{ fontSize: 12 }}>{formatDate(report.created_at)}</span>
                          <span style={{ fontSize: 18, fontWeight: 'bold' }}>{report.title}</span>
                        </Col>
                      </Row>
                      <Row>
                        {index !== reportsData.length - 1 && (
                          <Col className="col-2 d-flex justify-content-center">
                            <p
                              style={{
                                width: 2,
                                height: '100%',
                                backgroundColor: '#C3C3C3',
                              }}
                            ></p>
                          </Col>
                        )}
                      </Row>
                    </div>
                  ))}
                  <Col className="col-12 mt-3 mb-3">
                    <Button className={styles.loaadMoreBtn} onClick={handleLoadMore}>
                      Carregar 10 próximos
                    </Button>
                  </Col>
                </div>
              )}
            </div>
          )}
        </Row>
      </Modal.Body>
    </Modal>
  )
}

export default VehicleHistoricalModal
